import { Schema } from '@gitbook/slate';

import { INLINE_EXPRESSION, INLINE_LINK, LEAF_TEXT_BLOCKS } from '../types';

export const schema = Schema.create({
    inlines: {
        [INLINE_EXPRESSION]: {
            isVoid: true,
            parent: { types: [...LEAF_TEXT_BLOCKS, INLINE_LINK] },
            data: {
                expression: (expr) => typeof expr === 'string',
            },
        },
    },
});
